// 内部の解像度 = 論理画面 (ARENA 960x540) の何倍の画素で描くか。 既定 2.6 (= 2496x1404)。
// 案B (10-18・作者の答え「測って入れる」): 寄せ 1.3 倍の時に寄せた範囲がちょうど 1920 幅になる 2.6。
//   重さは RTX 4070 で 2 と差なし。 開発版は ?renderScale=2 で前の解像度に戻して見比べられる。
//   記録 = docs/research/2026-10-18-cam-zoom-bg-resolution.md
// 起動時 (main.ts が canvas の大きさを決める前) に一度だけ決める。 途中で変えない (裏バッファの大きさが固定のため)。
// shadowBlur と filter の blur(px) は変換を受けない = 画素で効く。 コードの値は 2 倍の時に合わせてあるので、
//   blurPx() と compensateShadowBlur() で 2 倍の時と同じ見た目の広がりにそろえる。
// コードの shadowBlur・blur の値を合わせてある解像度 (補正の基準)。
export const RENDER_SCALE_BASE = 2
export const RENDER_SCALE_DEFAULT = 2.6

let scale = RENDER_SCALE_DEFAULT

export function renderScale(): number { return scale }

export function setRenderScale(s: number): void {
  if (Number.isFinite(s) && s >= 1 && s <= 4) scale = s
}

export function readRenderScaleFromUrl(search: string): void {
  const v = new URLSearchParams(search).get('renderScale')
  if (v !== null) setRenderScale(Number(v))
}

// 2 倍の時に合わせた blur の画素数を、 今の解像度へ直す。
export function blurPx(px: number): number { return px * scale / RENDER_SCALE_BASE }

// この ctx に書く shadowBlur を、 今の解像度へ直して効かせる (2 倍の時は何もしない)。
const patched = new WeakSet<CanvasRenderingContext2D>()
export function compensateShadowBlur(ctx: CanvasRenderingContext2D): void {
  const k = scale / RENDER_SCALE_BASE
  if (k === 1 || patched.has(ctx)) return
  const d = Object.getOwnPropertyDescriptor(CanvasRenderingContext2D.prototype, 'shadowBlur')
  if (!d?.get || !d.set) return
  const get = d.get, set = d.set
  Object.defineProperty(ctx, 'shadowBlur', {
    configurable: true,
    get() { return get.call(this) / k },
    set(v: number) { set.call(this, v * k) },
  })
  patched.add(ctx)
}
